import { Dimensions, StyleSheet } from 'react-native';

import { lightGrey } from 'utils/colors';
import { widthPercentageToDP } from 'utils/responsiveness';

export const tabletEmbeddedProgressWidth = widthPercentageToDP(0, 687, 687);

const styles = StyleSheet.create({
    flexRow: {
        flexDirection: 'row',
    },
    container: {
        position: 'absolute',
        bottom: 48,
        width: '100%',
        alignSelf: 'center',
    },
    tabletEmbeddedContainer: {
        position: 'absolute',
        bottom: 12,
        width: tabletEmbeddedProgressWidth,
        alignSelf: 'center',
    },
    mobileEmbeddedContainer: {
        position: 'absolute',
        bottom: 8,
        width: '100%',
        alignSelf: 'center',
    },
    sliderContainer: {
        flex: 1,
        flexDirection: 'row',
        height: 30,
        justifyContent: 'space-between',
    },
    phoneEmbeddedSliderContainer: {
        justifyContent: 'center',
    },
    textLeft: { alignSelf: 'center', textAlign: 'left' },
    textRight: { alignSelf: 'center', textAlign: 'right' },
    slider: { alignSelf: 'center' },
    mobileEmbeddedSlider: {
        alignSelf: 'center',
        width:
            Math.min(
                Dimensions.get('window').width,
                Dimensions.get('window').height,
            ) - 32,
    },
    thumb: { backgroundColor: lightGrey() },
    mockedProgressTime: { position: 'absolute', top: 0, left: 0, opacity: 0 },
});

export default styles;
